import { Box, styled } from '@ltvco/refresh-lib/theme';

export const EmailHeaderRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: 16,
});

export const EmailHeaderLeft = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
});

export const HeaderTitle = styled('span')(({ theme }) => ({
  fontSize: 18,
  fontWeight: 700,
  color: theme.palette.text.primary,
}));

export const HeaderActions = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  color: theme.palette.text.secondary,
  cursor: 'pointer',
}));

export const EmailAddress = styled('span')(({ theme }) => ({
  fontSize: 20,
  fontWeight: 700,
  color: theme.palette.text.primary,
  display: 'block',
  marginBottom: 4,
}));

export const EmailType = styled('span')(({ theme }) => ({
  fontSize: 14,
  color: theme.palette.text.secondary,
  display: 'block',
  marginBottom: 4,
}));

export const SectionDivider = styled('hr')(({ theme }) => ({
  border: 'none',
  borderTop: `1px solid ${theme.palette.divider}`,
  margin: '16px 0',
}));

export const SectionHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  marginBottom: 12,
  color: theme.palette.rats.main,
}));

export const SectionTitle = styled('span')({
  fontSize: 15,
  fontWeight: 600,
});

export const DetailGrid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '185px 1fr',
  rowGap: 8,
});

export const DetailLabel = styled('span')(({ theme }) => ({
  fontSize: 14,
  fontWeight: 600,
  color: theme.palette.rats.main,
}));

export const DetailValue = styled('span')(({ theme }) => ({
  fontSize: 14,
  color: theme.palette.text.primary,
}));

export const OwnerRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  marginBottom: 16,
});

export const OwnerInfo = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 10,
});

export const OwnerAvatar = styled(Box)(({ theme }) => ({
  width: 36,
  height: 36,
  borderRadius: '50%',
  backgroundColor: theme.palette.button.light,
  color: theme.palette.primary.main,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 13,
  fontWeight: 600,
  flexShrink: 0,
}));

export const OwnerName = styled('span')(({ theme }) => ({
  fontSize: 16,
  fontWeight: 700,
  color: theme.palette.text.primary,
}));
